export const MY_PURCHASES = '/my-purchases'
export const CHECKOUT_DELIVERY_PATHNAME = '/checkout/delivery'
export const CHECKOUT_GIFT_VOUCHER_PATHNAME = '/checkout/gift-voucher'
export const CHECKOUT_AUTHENTICATION_PATHNAME = '/checkout/authentication'
export const MY_CARDS = '/my-cards'
